import RequestCreator from './BaseRequest';

class FaceValidation extends RequestCreator<any> {}

const api = new FaceValidation('/face-validation');
export default api;
